(() => {
  const PROTECTION_VARIANT_ID = 53489473257805;

  let shippingBusy = false;
  let discountBusy = false;
  let initialized = false;

  function log(...args) {
    console.log('[cart-enhancements]', ...args);
  }

  function getShopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function cartUrl(path) {
    const root = getShopifyRoot().replace(/\/$/, '');
    const cleanPath = path.replace(/^\//, '');
    return `${root}/${cleanPath}`;
  }

  function getHorizonCartDrawer() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-drawer-component') ||
      document.querySelector('[data-cart-drawer]')
    );
  }

  function isCartDrawerOpen() {
    const drawer = getHorizonCartDrawer();

    if (!drawer) return false;

    return (
      drawer.open === true ||
      drawer.hasAttribute('open') ||
      drawer.classList.contains('is-open') ||
      drawer.getAttribute('aria-hidden') === 'false'
    );
  }

  function ensureCartDrawerOpen(itemCount = null) {
    const drawer = getHorizonCartDrawer();

    if (isCartDrawerOpen()) {
      return true;
    }

    if (drawer) {
      try {
        drawer.open = true;
      } catch (error) {
        console.error('[cart] drawer.open failed:', error);
      }
    }

    try {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              itemCount: typeof itemCount === 'number' ? itemCount : undefined,
              source: 'product-form-component'
            }
          }
        })
      );
    } catch (error) {
      console.error('[cart] cart:update dispatch failed:', error);
    }

    return true;
  }

  async function getCart() {
    const response = await fetch(cartUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart ophalen mislukt');
    }

    return response.json();
  }

  async function addProtection() {
    const response = await fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: PROTECTION_VARIANT_ID,
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async function removeProtection() {
    const response = await fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [PROTECTION_VARIANT_ID]: 0
        }
      })
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async function updateCartDiscount(discountValue) {
    const response = await fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: discountValue
      })
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  function getAppliedDiscountCodesFromDom() {
    return Array.from(
      document.querySelectorAll('.cart-discount__applied-row[data-discount-code]')
    )
      .map((el) => (el.getAttribute('data-discount-code') || '').trim())
      .filter(Boolean);
  }

  function setDiscountLoadingState(form, isLoading) {
    if (!form) return;

    const input = form.querySelector('[data-cart-discount-input]');
    const button = form.querySelector('[data-cart-discount-apply]');

    if (input) input.disabled = isLoading;
    if (button) button.disabled = isLoading;
  }

  function clearDiscountError() {
    const errorBox = document.querySelector('.cart-discount__error');
    if (!errorBox) return;

    errorBox.classList.add('hidden');

    errorBox.querySelectorAll('.cart-discount__error-text').forEach((el) => {
      el.classList.add('hidden');
    });
  }

  function showDiscountError(message) {
    const errorBox = document.querySelector('.cart-discount__error');
    if (!errorBox) {
      console.error('[discount]', message);
      return;
    }

    errorBox.classList.remove('hidden');

    const texts = errorBox.querySelectorAll('.cart-discount__error-text');
    texts.forEach((el) => el.classList.add('hidden'));

    const target =
      errorBox.querySelector('[ref="cartDiscountErrorDiscountCode"]') ||
      texts[0];

    if (target) {
      target.textContent = message;
      target.classList.remove('hidden');
    }
  }

  async function fetchCurrentPageDocument() {
    const url = new URL(window.location.href);
    url.searchParams.set('_cart_ui_refresh', String(Date.now()));

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('Nieuwe cart HTML ophalen mislukt');
    }

    const html = await response.text();
    const parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  }

  function replaceIfFound(selectors, newDoc) {
    for (const selector of selectors) {
      const currentEl = document.querySelector(selector);
      const newEl = newDoc.querySelector(selector);

      if (currentEl && newEl) {
        currentEl.replaceWith(newEl);
        return true;
      }
    }

    return false;
  }

  async function refreshCartUi() {
    const newDoc = await fetchCurrentPageDocument();

    replaceIfFound(
      [
        '.cart-products',
        '.cart__items',
        '.cart-items',
        '.cart-drawer__items'
      ],
      newDoc
    );

    replaceIfFound(
      [
        '.cart__summary-totals'
      ],
      newDoc
    );

    replaceIfFound(
      [
        '.cart__ctas'
      ],
      newDoc
    );

    replaceIfFound(
      [
        '#cart-icon-bubble',
        '.cart-count-bubble',
        '.cart-bubble',
        '[data-testid="cart-count"]'
      ],
      newDoc
    );
  }

  async function syncShippingToggle() {
    const toggle = document.querySelector('[data-shipping-protection-toggle]');
    if (!toggle || shippingBusy) return;

    try {
      const cart = await getCart();
      const exists = cart.items.some(
        (item) => Number(item.variant_id) === PROTECTION_VARIANT_ID
      );

      toggle.checked = exists;
    } catch (error) {
      console.error('[shipping] sync error:', error);
    }
  }

  async function onShippingToggleChange(toggle) {
    if (!toggle || shippingBusy) return;

    const shouldEnable = toggle.checked;
    shippingBusy = true;
    toggle.disabled = true;

    try {
      const cartBefore = await getCart();
      const exists = cartBefore.items.some(
        (item) => Number(item.variant_id) === PROTECTION_VARIANT_ID
      );

      if (shouldEnable && !exists) {
        await addProtection();
      } else if (!shouldEnable && exists) {
        await removeProtection();
      }

      const cartAfter = await getCart();
      await refreshCartUi();
      ensureCartDrawerOpen(cartAfter.item_count);
    } catch (error) {
      console.error('[shipping] toggle error:', error);
      await syncShippingToggle();
    } finally {
      shippingBusy = false;

      if (document.body.contains(toggle)) {
        toggle.disabled = false;
      }
    }
  }

  async function applyDiscountFromForm(form) {
    if (!form || discountBusy) return;

    const input = form.querySelector('[data-cart-discount-input]');
    if (!input) return;

    const newCode = input.value.trim();
    if (!newCode) return;

    discountBusy = true;
    clearDiscountError();
    setDiscountLoadingState(form, true);

    try {
      const existingCodes = getAppliedDiscountCodesFromDom();
      const combinedCodes = Array.from(new Set([...existingCodes, newCode]));

      await updateCartDiscount(combinedCodes.join(','));
      const cartAfter = await getCart();
      await refreshCartUi();
      ensureCartDrawerOpen(cartAfter.item_count);
    } catch (error) {
      console.error('[discount] apply error:', error);
      showDiscountError('Ongeldige kortingscode of korting kon niet worden toegepast.');
    } finally {
      discountBusy = false;
      setDiscountLoadingState(form, false);
    }
  }

  async function removeDiscountByCode(code, button) {
    if (discountBusy) return;

    const codeToRemove = (code || '').trim();
    if (!codeToRemove) return;

    discountBusy = true;
    clearDiscountError();

    if (button) {
      button.disabled = true;
    }

    try {
      const existingCodes = getAppliedDiscountCodesFromDom();
      const remainingCodes = existingCodes.filter(
        (existingCode) => existingCode.toLowerCase() !== codeToRemove.toLowerCase()
      );

      await updateCartDiscount(remainingCodes.join(','));
      const cartAfter = await getCart();
      await refreshCartUi();
      ensureCartDrawerOpen(cartAfter.item_count);
    } catch (error) {
      console.error('[discount] remove error:', error);
      showDiscountError('Kortingscode kon niet worden verwijderd.');

      if (button) {
        button.disabled = false;
      }
    } finally {
      discountBusy = false;
    }
  }

  function initDiscountHandlers() {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.matches('[data-cart-discount-form]')) return;

      event.preventDefault();
      applyDiscountFromForm(form);
    });

    document.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-cart-discount-remove]');
      if (removeButton) {
        event.preventDefault();
        const code = removeButton.getAttribute('data-discount-code') || '';
        removeDiscountByCode(code, removeButton);
      }
    });
  }

  function initShippingHandlers() {
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || !target.matches('[data-shipping-protection-toggle]')) return;
      onShippingToggleChange(target);
    });
  }

  function init() {
    if (initialized) return;
    initialized = true;

    log('init');

    initShippingHandlers();
    initDiscountHandlers();
    syncShippingToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();